module.exports = __webpack_public_path__ + "img/calendar.67c58325.png";